/** Drag payload for JsonDraggableTree rows (root Live Test body maps to `$`). */
export function dragPathForTreeRow(path: string): string {
  const trimmed = path.trim();
  return trimmed || '$';
}

export function jsonataExpressionForPath(path: string): string {
  const trimmed = path.trim();
  if (!trimmed) return '';
  if (trimmed === '$') return '$';
  const segments = trimmed.split('.').filter(Boolean);
  if (segments.length === 0) return '$';
  const rendered = segments.map(segment => {
    const base = segment.replace(/\[(?:\d*)\]$/g, '');
    const indexes = Array.from(segment.matchAll(/\[(\d*)\]/g)).map(match => match[1] ? `[${match[1]}]` : '');
    const renderedBase = /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(base)
      ? base
      : `"${base.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
    return `${renderedBase}${indexes.join('')}`;
  });
  return `$.${rendered.join('.')}`;
}

/** True when the user entered a JSONata expression instead of a dotted vendor path. */
export function looksLikeResponseMappingExpression(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || trimmed === '$') return false;
  if (trimmed.startsWith('(') || trimmed.startsWith('data.')) return true;
  if ((trimmed.includes(' ? ') || trimmed.includes(':')) && /[=!<>]/.test(trimmed)) return true;
  return false;
}

/** Builds the stored responseMapping expression from a path or full JSONata fragment. */
export function responseMappingExpressionForInput(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return '';
  if (looksLikeResponseMappingExpression(trimmed)) return trimmed;
  return jsonataExpressionForPath(trimmed);
}
